function extractIdFromUrl(url: string): string | null {
  try {
   
    // give regex for to get id from above url for example 6045332
    const idMatch = url.match(/\?id=(\d+)/);
    if (idMatch && idMatch[1]) {
      return idMatch[1];
    }
    return null;
  } catch (error) {
    return null;
  }
  }

  export default extractIdFromUrl